import { useMemo } from 'react';

import { issueStatuses, issueStatusesByCode } from 'entities';

import { DateRange } from 'components/Blocks';

import { useUrlStateV2 } from 'hooks';

import { formatDate, isValidYYYYmmDD, reviveDates, serializeDates, subDays } from 'utils/date';
import { quickContext } from 'utils/react';

const today = new Date();

const { useIssuesHome, withIssuesHomeContext } = quickContext('issuesHome', () => {
  const [state, dispatch] = useUrlStateV2({
    status: {
      defaultValue: issueStatuses.active.code,
      validate: (s) => !!issueStatusesByCode[s],
    },

    from: {
      defaultValue: formatDate(subDays(today, 6), 'yyyy-mm-dd'),
      validate: (from, { to }) => isValidYYYYmmDD(from) && isValidYYYYmmDD(`${to}`) && from <= to,
    },

    to: {
      defaultValue: formatDate(today, 'yyyy-mm-dd'),
      validate: (to, { from }) => isValidYYYYmmDD(to) && isValidYYYYmmDD(`${from}`) && to >= from,
    },
  });

  return {
    data: useMemo(
      () => ({
        dispatch,
        state: {
          ...state,
          ...reviveDates(state, ['from', 'to']),
        },

        updateDates: (range: DateRange) => dispatch(serializeDates(range)),
      }),
      [state, dispatch],
    ),
  };
});

export { useIssuesHome, withIssuesHomeContext };
